import React from 'react';
import { Wrapper } from './APStats.styles';
import ChartsWrapper from './ChartsWrapper';

const APStats = () => {
	return (
		<Wrapper>
			<ChartsWrapper />
		</Wrapper>
	);
};

export default APStats;
